import { OpenAPISchemas as BaseOpenAPISchemas } from '@gitbook/react-openapi';
import { Icon } from '@gitbook/spine-icons';

import '../../../OpenAPI/react-openapi.css';
import '../scalar.css';

import { type BlockOpenAPISchemasData, createEditorValue } from '@gitbook/doc-core';
import type { Filesystem, OpenAPISchema } from '@gitbook/openapi-parser';
import { PlainCodeBlock } from '@gitbook/react-uikit';
import { type DocumentJSON, deserialize } from '@gitbook/slate';
import { Editor } from '@gitbook/slate-react';
import { Heading } from '@gitbook/spine-react';

import { mainPlugin } from '../../renderer';
import { OpenAPIBlockContent } from '../OpenAPIBlockContent';
import { useResolveOpenAPI } from '../useResolveOpenAPI';

/**
 * Content of an OpenAPI schemas block.
 */
export function OpenAPISchemasBlockContent(props: {
    specUrl: string;
    filesystem: Filesystem;
    data: BlockOpenAPISchemasData;
}) {
    const {
        specUrl,
        filesystem,
        data: { schemas, grouped },
    } = props;

    const result = useResolveOpenAPI<{ schemas: OpenAPISchema[] }>({ filesystem, schemas });

    return (
        <OpenAPIBlockContent type="schemas" resolved={result}>
            {({ data }) => (
                <BaseOpenAPISchemas
                    schemas={data.schemas}
                    grouped={grouped}
                    context={{
                        locale: 'en',
                        icons: {
                            chevronDown: <Icon.ChevronDown />,
                            chevronRight: <Icon.ChevronRight />,
                            plus: <Icon.Plus />,
                        },
                        defaultInteractiveOpened: false,
                        specUrl,
                        renderCodeBlock: (codeProps) => (
                            <PlainCodeBlock className="openapi-codeblock" {...codeProps} />
                        ),
                        renderHeading: ({ deprecated, title }) => (
                            <Heading className={deprecated ? 'line-through' : undefined} level={2}>
                                {title}
                            </Heading>
                        ),
                        renderDocument: (documentProps: { document: DocumentJSON }) => {
                            const value = createEditorValue(deserialize(documentProps.document));
                            return (
                                <Editor
                                    value={value}
                                    readOnly
                                    onChange={() => {}}
                                    plugins={[mainPlugin]}
                                />
                            );
                        },
                    }}
                    className="openapi-schemas-block"
                />
            )}
        </OpenAPIBlockContent>
    );
}
